import React from 'react';
import { Button } from './Button';

interface SaveDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
}

export const SaveDraftModal: React.FC<SaveDraftModalProps> = ({
  isOpen,
  onClose,
  onSave,
  onDiscard
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-[#131B2C] border border-white/10 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6">
          <h3 className="text-xl font-black text-white uppercase tracking-tight mb-2">Save Project as Draft?</h3>
          <p className="text-text-secondary text-sm">
            You have unsaved project details. Would you like to save them as a draft and continue later?
          </p>
        </div>
        <div className="p-4 bg-white/[0.02] border-t border-white/5 flex justify-end gap-3">
          <Button variant="ghost" onClick={onClose} className="text-text-secondary hover:text-white">
            Cancel
          </Button>
          <Button variant="outline" onClick={onDiscard} className="border-error/20 text-error hover:bg-error/10 hover:border-error/30">
            Discard
          </Button>
          <Button onClick={onSave} className="bg-primary hover:bg-primary/90 text-white border-none">
            Save as Draft
          </Button>
        </div>
      </div>
    </div>
  );
};
